export const APP_VERSION = '2.8.12';
